export default __webpack_public_path__ + "static/media/gcashLogo.72e664a7.svg";